import { OneDriveReportProfileAlertDelegateModel } from '../../../microsoft/onedrive/profile/one-drive-report-profile-alert-delegate-model';
import { ReportProfileAlertResourceBaseModel } from '../../../profile/report-profile-alert-resource-base-model';

export class OneDriveReportProfileAlertExternalDelegatesModel extends ReportProfileAlertResourceBaseModel {
  delegates: OneDriveReportProfileAlertDelegateModel[];
}
